import { render } from "./global.vue?vue&type=template&id=70da734d"
import script from "./global.vue?vue&type=script&setup=true&lang=js"
export * from "./global.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "C:\\essoduke\\Web\\health-click.dev\\app\\site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/assets/js/hcv2/vue/components/global.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "70da734d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('70da734d', __exports__)) {
    console.log('reload')
    api.reload('70da734d', __exports__)
  }
  
  module.hot.accept("./global.vue?vue&type=template&id=70da734d", () => {
    console.log('re-render')
    api.rerender('70da734d', render)
  })

}


export default __exports__